import merge from 'lodash/merge';
import * as types from '../constants';

const byId = (state = {}, action) => {
  if (action.response) {
    return {
      ...state,
      ...action.response.entities.customers,
    };
  }

  switch (action.type) {
    case types.UPDATE_CUSTOMER: {
      const data = {};
      data[action.customer.id] = merge({}, state[action.customer.id], action.customer);
      return { ...state, ...data };
    }
    case types.ADD_CUSTOMER_PHOTO: {
      const data = {};
      data[action.customerId] = merge({}, state[action.customerId], { photos: [action.photo] });
      return { ...state, ...data };
    }
    default:
      return state;
  }
};

export default byId;
